var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#DDF5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 26V15C11.5 11 12.5 10 16.5 10H23.5C27.5 10 28.5 11 28.5 15V25C28.5 25.14 28.5 25.28 28.49 25.42",
    stroke: "#07B9CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.35 23H28.5V26.5C28.5 28.43 26.93 30 25 30H15C13.07 30 11.5 28.43 11.5 26.5V25.85C11.5 24.28 12.78 23 14.35 23Z",
    stroke: "#07B9CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15H24",
    stroke: "#07B9CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.5H21",
    stroke: "#07B9CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNative);
export default __webpack_public_path__ + "static/media/native.caa31c94b68f697e90f1e1fde31f5bbb.svg";
export { ForwardRef as ReactComponent };